import { InputModel } from '../components/input/input.model';
import { RequiredModel } from '../components/input/rules/implementations/required.model';
import { EmailModel } from '../components/input/rules/implementations/email.model';
import { UserModel } from './user.model';
import { CPFModel } from '../components/input/rules/implementations/cpf.model';

export class LoginModel {
  username: string;
  usernameInputModel: InputModel = new InputModel(true, false, 'email', 'E-mail', [new RequiredModel(), new EmailModel()]);
  password: string;
  passwordInputModel: InputModel = new InputModel(true, false, 'password', 'Digite sua senha', [new RequiredModel()]);
}

export class TokenModel {
  access_token: string;
  expires_in: number;
  usuarioMeep: UserModel;
}

export class RegisterModel {
  nome: string;
  nomeInputModel: InputModel = new InputModel(true, false, 'text', 'Nome', [new RequiredModel()]);
  cpf: string;
  cpfInputModel: InputModel = new InputModel(true, false, 'tel', 'CPF', [new RequiredModel(), new CPFModel()], new CPFModel);
  email: string;
  emailInputModel: InputModel = new InputModel(true, false, 'email', 'E-mail', [new RequiredModel(), new EmailModel()]);
  senha: string;
  senhaInputModel: InputModel = new InputModel(true, false, 'password', 'Senha', [new RequiredModel()]);
  confirmarSenha: string;
  confirmarSenhaInputModel: InputModel = new InputModel(true, false, 'password', 'Confirmar Senha', [new RequiredModel()]);
  ehBrasileiro: boolean;
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/login.model.ts